 
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ManageCSIOEdocs } from "../../../../../csioEdocs/ManageCSIOEdocs";
import { IBreadcrumbProps } from "../../../../../../layout/fullLayout/breadcrumb/IBreadcrumbProps";

export const BusinessCSIOEDocsWrapper: React.FC = () => {
  const { customerId, customerPolicyId, csioEdocsId, type } = useParams() as {
    customerId: string;
    customerPolicyId: string;
    csioEdocsId?: string;
    type?: string;
  };

  const isUpdate = csioEdocsId ? true : false;

  const defaultBreadcrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: `/business-policy/${customerId}/csio-edocs-list/${customerPolicyId}`,
      title: "CSIO EDOCS LIST",
    },
    {
      title: csioEdocsId ? "Update CSIO EDOCS" : "Create CSIO EDOCS",
    },
  ];

  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate(
      `/business-policy/${customerId}/csio-edocs-list/${customerPolicyId}`
    );
  };

  const defaultValidation = (values: any) => {
    const errors: any = {};
    const errorMessage = "This field is required.";
    if (!values.policy_number) {
      errors.policy_number = errorMessage;
    } else if (!values.customer_id) {
      errors.customer_id = errorMessage;
    } else if (!values.type) {
      errors.type = errorMessage;
    } else if (!values.business_purpose_type) {
      errors.business_purpose_type = errorMessage;
    }
    return errors;
  };

  const validation = defaultValidation;

  return (
    <ManageCSIOEdocs
      csioEdocsId={csioEdocsId}
      isUpdate={isUpdate}
      onSuccess={handleSuccess}
      validation={validation}
      breadcrumbItems={defaultBreadcrumb}
      customerId={customerId}
      customerPolicyId={customerPolicyId}
      type={type as "guid"}
    />
  );
};
